import React from 'react';
import { MDBBtn } from 'mdb-react-ui-kit';
import { connect } from 'react-redux';
import { baseURL } from '../api/baseURL';

// Browser-navigated downloads can't set an Authorization header, so the token
// travels as a query param — every Admin Server handler already accepts that
// as a fallback (see verifyAdmin in src/apis/export.js).
// `small` is the compact variant used inside dashboard cards; it is tagged
// data-html2canvas-ignore so the page's PDF screenshot doesn't include buttons.
const ExportButton = ({ endpoint, token, label, extraQuery, small }: { endpoint: string, token?: string, label?: string, extraQuery?: string, small?: boolean }) => {
    const href = `${baseURL}${endpoint}?token=${encodeURIComponent(token || '')}${extraQuery ? `&${extraQuery}` : ''}`;
    return (
        <MDBBtn
            tag="a"
            href={href}
            color='secondary'
            rippleColor='light'
            size={small ? 'sm' : undefined}
            data-html2canvas-ignore="true"
            style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ...(small ? { padding: '3px 10px', fontSize: 10.5 } : {}) }}
        >
            {label || 'Export to Excel'}
        </MDBBtn>
    );
}

const mapStateToProps = (state: any) => ({
    token: state.auth?.token,
});

export default connect(mapStateToProps)(ExportButton);
